import { IAction } from '../model/IAction';

import * as FetchActions from '../actions/FetchDataItems';
import { UserSnippet } from "../actions/SnippetActions";

export function snippets(state: UserSnippet[] = [], action: IAction): UserSnippet[] {
    switch (action.type) {
        case FetchActions.RECEIVE_USER_SNIPPETS:
            const receiveAction = action as FetchActions.IReceiveUserSnippetsAction;
            let stateCopy: UserSnippet[] = Object.assign([], state);
            stateCopy = receiveAction.userSnippets
            return stateCopy;
        default:
            return state;
    }
}

